export const PAYMENT_METHODS = {
  WECHAT: 'WECHAT',
  ALIPAY: 'ALIPAY'
};
